module.exports = __webpack_public_path__ + "static/media/tile-price-5.444e9f95.jpg";